const ArrowRight = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M51.567 32.967l-15.35-15.35a1.948 1.948 0 0 1 .346-2.686 1.709 1.709 0 0 1 2.482-.142L54.4 30.139z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M52.172 27.959L36.094 44.037a1.948 1.948 0 0 0 .346 2.686 1.709 1.709 0 0 0 2.483.142L55 30.788z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M50.176 29h-35.3a1.793 1.793 0 0 0-1.717 2 1.931 1.931 0 0 0 1.717 2h35.3z"
      fill={color}
    ></path>
  </svg>
);

export default ArrowRight;
